module.exports = __webpack_public_path__ + "/img/TO-DPAK-3yAbdn.svg";